// reducers/doctorReducer.js
import { createSlice } from '@reduxjs/toolkit';

const doctorSlice = createSlice({
  name: 'doctor',
  initialState: {
    doctorsList: [],
    totalNumberOfDoctor: 0,
    totalNumberOfDoctorRecievedMessageWithInweek: 0,
    doctorsListSelected: [],
    divisionList: [],
    specialityList: [],
    countryList: [],
    isAllDoctorSelected: false, // In send Message page needs to check if all selected true then show pop up and total count
    filterDoctorListParam: {
      division: '',
      speciality: '',
      country: '',
      search: '',
    },
  },
  reducers: {
    setDoctorDetails: (state, action) => {
      state.doctorsList = action.payload;
    },
    setTotalNumberOfDoctor: (state, action) => {
      state.totalNumberOfDoctor = action.payload;
    },
    setTotalNumberOfDoctorRecievedMessagewithinweek: (state, action) => {
      state.totalNumberOfDoctorRecievedMessageWithInweek = action.payload;
    },
    setDoctorsListSelected: (state, action) => {
      state.doctorsListSelected = action.payload;
    },
    setDivisionList: (state, action) => {
      state.divisionList = action.payload;
    },
    setSpecialityList: (state, action) => {
      state.specialityList = action.payload;
    },
    setCountryList: (state, action) => {
      state.countryList = action.payload;
    },
    updateFilterDoctorListParam: (state, action) => {
      state.filterDoctorListParam = action.payload;
    },
    updateAllDoctorSelected: (state, action) => {
      state.isAllDoctorSelected = action.payload;
    },
  },
});

export const {
  setDoctorDetails,
  setDoctorsListSelected,
  setDivisionList,
  setSpecialityList,
  setCountryList,
  updateFilterDoctorListParam,
  updateAllDoctorSelected,
  setTotalNumberOfDoctor,
  setTotalNumberOfDoctorRecievedMessagewithinweek,
} = doctorSlice.actions;

export default doctorSlice.reducer;
